// Text
export { default as Text } from "./Text";
export type { default as TextProps } from "./TextProps.interface";